class SearchStringOrIntReq {
    constructor(){
        this.SearchString = undefined;
        this.SearchInt = undefined;
        this.HoursIndex = undefined;
        this.SearchDate = undefined;
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        };
        this.sessionName = undefined;  
        this.patientId = undefined;     
        this.therapistId = undefined;
    }
}

export default SearchStringOrIntReq;